export default __webpack_public_path__ + "static/media/top-banner.29b9ebd3.png";